const Renewal = () => import('@/pages/renewal/Renewal');
export default {
  path: '/renewal/:no',
  component: Renewal,
  name: 'Renewal', 
  props: route => ({
    ...route.params
  }), 
}